import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const List = styled.div`
    display: flex;
    flex-direction: column;
    padding: 6px 0;
    min-width: 220px;
`;

export const SheetList = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
`;

export const Row = styled.button<{ $tone: "default" | "danger"; $inSheet: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    /* 52px в листе — минимальная комфортная зона нажатия на телефоне. */
    min-height: ${({ $inSheet }) => ($inSheet ? "52px" : "40px")};
    padding: ${({ $inSheet }) => ($inSheet ? "8px 4px" : "6px 16px")};
    border: none;
    border-radius: ${({ $inSheet }) => ($inSheet ? radii.order : "0")};
    background: transparent;
    font-family: inherit;
    font-size: 15px;
    color: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.textPrimary)};
    text-align: left;
    cursor: pointer;

    svg {
        font-size: 20px;
        color: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.textSecondary)};
    }

    &:hover:not(:disabled) {
        background: ${({ $tone }) =>
            $tone === "danger" ? colors.dangerHover : "rgba(0,0,0,0.04)"};
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const Text = styled.span`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const Hint = styled.span`
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const Divider = styled.div`
    height: 1px;
    margin: 6px 0;
    background: ${colors.borderSoft};
`;
